export default {
  title: 'Playground',

  navigation: {
    squircle: 'Squircle',
    sticker: 'Sticker',
    button: 'Button',
    tag: 'Tag',
    gSelect: 'GSelect',
    gTextField: 'GTextField',
    gTextarea: 'GTextarea',
    gSnackbar: 'GSnackbar',
    contactLists: 'ContactLists'
  },

  squircle: {
    title: 'Squircle'
  },

  sticker: {
    title: 'Sticker',

    statuses: {
      active: 'Activo'
    }
  },

  button: {
    title: 'Button'
  },

  tag: {
    title: 'Tag'
  },

  g: {
    select: {
      title: 'GSelect'
    },

    'text-field': {
      title: 'GTextField'
    },

    textarea: {
      title: 'GTextarea'
    },

    snackbar: {
      title: 'GSnackbar'
    }
  },

  contactLists: {
    title: 'ContactLists',

    groups: {
      controls: 'Controles',
      transport: 'Transporte y rutas',
      create: 'Creación',
      get: 'Obtención',
      find: 'Búsqueda',
      update: 'Actualización',
      remove: 'Eliminación'
    },

    labels: {
      controls: 'Ejecución de casos',
      fixture: 'Fixture',
      expected: 'Esperado',
      actual: 'Respuesta',
      cleanupError: 'El registro creado no se eliminó',
      log: 'Registro de solicitudes',
      logEmpty: 'Todavía no hay solicitudes'
    },

    actions: {
      run: 'Ejecutar',
      runAll: 'Ejecutar todo',
      createFixture: 'Crear fixture',
      removeFixture: 'Eliminar fixture',
      reset: 'Restablecer',
      clearLog: 'Limpiar el registro'
    },

    cases: {
      transport: {
        invalidToken: 'El token de la cabecera Authorization no pasa la validación',
        unknownPath: 'La ruta no está declarada en las rutas de la API',
        wrongMethod: 'El método PATCH no está declarado para el recurso',
        malformedBody: 'El cuerpo de la solicitud no es un JSON válido'
      },

      create: {
        emptyBody: 'Creación sin los campos obligatorios',
        emptyTitle: 'title vacío',
        htmlTitle: 'title contiene solo una etiqueta HTML y el sanitizador la elimina',
        longTitle: 'title supera los 150 caracteres',
        forbiddenCharacterTitle: 'title contiene un carácter fuera del conjunto permitido',
        numberTitle: 'title se envía como número y se convierte en cadena',
        unknownType: 'Un type desconocido se sustituye por regular',
        invalidOwnerId: 'Un OwnerId inválido se descarta y se sustituye por el propietario del token'
      },

      get: {
        missing: 'Solicitud de una lista que no existe',
        invalidId: 'El identificador no se puede convertir al tipo uuid',
        objectScope: 'El parámetro $scope se envía como objeto en lugar de cadena o arreglo'
      },

      find: {
        limitNotNumber: 'El parámetro $limit no es un número',
        limitNegative: 'El parámetro $limit es menor que cero',
        offsetNotNumber: 'El parámetro $offset no es un número',
        objectOrder: 'El parámetro $order se envía como objeto en lugar de cadena o arreglo',
        invalidIdFilter: 'El filtro id con un uuid inválido se descarta y la selección se devuelve completa'
      },

      update: {
        missing: 'Actualización de una lista que no existe',
        invalidId: 'El identificador no se puede convertir al tipo uuid',
        emptyTitle: 'title vacío en una lista existente',
        longTitle: 'title supera los 150 caracteres en una lista existente',
        forbiddenCharacterTitle: 'title con un carácter fuera del conjunto permitido en una lista existente',
        idInBody: 'El campo id del cuerpo de la solicitud se ignora'
      },

      remove: {
        missing: 'Eliminación de una lista que no existe',
        invalidId: 'El identificador no se puede convertir al tipo uuid'
      }
    }
  },

  groups: {
    sizes: 'Tamaños',
    lineHeight: 'Line-height',
    modes: 'Modos',
    states: 'Estados',
    filledColors: 'Colores filled',
    outlineColors: 'Colores outline',
    iconContent: 'Contenido con icono',
    iconSizes: 'Icono y etiqueta: tamaños',
    iconOnlySizes: 'Solo icono: tamaños',
    iconModes: 'Icono y etiqueta: modos',
    iconSamples: 'Iconos diferentes',
    iconStates: 'Estados con icono',
    content: 'Contenido',
    colors: 'Colores',
    links: 'Enlaces y clic',
    actions: 'Acciones',
    borders: 'Bordes',
    progress: 'Progreso',
    messages: 'Ayuda y validación',
    multiple: 'Selección múltiple',
    selection: 'Elemento seleccionado',
    dropdown: 'Dropdown',
    rows: 'Altura y ancho',
    types: 'Tipos',
    interactive: 'Ejemplos interactivos',
    iconSVG: 'iconSVG',
    icons: 'Iconos',
    affixes: 'Prefijos y sufijos',
    tooltip: 'Tooltip',
    fullWidth: 'Ancho completo',
    slot: 'Slot',
    features: 'Propiedades',
    as: 'As',
    styles: 'Estilos',
    limits: 'Límites',
    resize: 'Resize',
    itemConfig: 'Configuración de items',
    freeInput: 'Free input',
    service: 'Carga desde el servicio',
    button: 'Botón',
    badges: 'Badges',
    width: 'Ancho',
    target: 'Target',
    allIcons: 'Todos los iconos',
    allColors: 'Todos los colores',
    duration: 'Duración'
  },

  empty: {
    icons: 'No se encontró nada'
  },

  labels: {
    button: 'Botón',
    copyIcon: 'Pulse para copiar el icono',
    copyColor: 'Pulse para copiar el color',
    defaultSlot: 'Slot por defecto',
    detailsAndCount: 'Hint y contador',
    detailsFalse: 'Sin bloque details',
    dropdownSlots: 'menuProps, icons y slots',
    growFalse: 'grow desactivado con valor multilínea',
    growInput: 'Crecimiento de altura al escribir',
    growLongValue: 'grow con valor multilínea',
    growShortValue: 'grow con valor corto',
    iconColorAndSize: 'iconColor e iconSize',
    inputError: 'Texto de error',
    inputHint: 'Texto de ayuda',
    inputLabel: 'Etiqueta',
    inputPlaceholder: 'Texto del placeholder',
    inputValue: 'Valor del campo',
    interactiveTag: 'Tag eliminable',
    itemConfig: 'itemsPrepend, itemsDisabled, itemTitle, itemValue, itemDisabled y picks',
    longLabel: 'Una etiqueta muy larga que no cabe en una sola línea',
    maskCard: 'Máscara de tarjeta',
    maskPhone: 'Máscara de teléfono',
    multipleHideSelections: 'multiple y hideSelections',
    restoreTag: 'Restaurar tag',
    runAllCases: 'Ejecutar todos los casos',
    servicePaths: 'service, pathToId, pathToTitle y translatePath',
    singleClearable: 'single y clearable',
    snackbarActionResult: 'La acción del snackbar se ha ejecutado',
    snackbarDurationText: 'Snackbar con duración en segundos:',
    snackbarQueueText: 'Snackbar de la cola',
    snackbarText: 'Texto corto del snackbar',
    stickerLabel: 'Descripción del sticker',
    stickerValue: 'Título del sticker',
    tag: 'Tag',
    tooltip: 'Texto del tooltip'
  }
}
